"use client";

import { MoonStarIcon, TerminalIcon } from "lucide-react";

import { truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface ToolCallDisplayProps {
  name: string;
  /** Pre-serialized JSON string. Parsed internally for pretty-printing; falls back to raw if parsing fails. */
  rawArgs: string;
  isStreaming?: boolean;
}

function prettyPrint(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

function getToolCallIcon(name: string) {
  if (name.toLowerCase() === "sleep") {
    return <MoonStarIcon className="h-3 w-3" />;
  }

  return <TerminalIcon className="h-3 w-3" />;
}

export const ToolCallDisplay = ({
  name,
  rawArgs,
  isStreaming,
}: ToolCallDisplayProps) => {
  const formatted = prettyPrint(rawArgs);
  return (
    <CollapsibleSection
      icon={getToolCallIcon(name)}
      label={name}
      preview={truncate(`${name}(${rawArgs})`)}
      copyContent={formatted}
      isStreaming={isStreaming}
    >
      <pre className="overflow-x-auto rounded-md bg-zinc-100 p-2 text-xs text-zinc-800">
        {formatted}
      </pre>
    </CollapsibleSection>
  );
};
